import { io } from 'socket.io-client';

const URL = 'https://ipio.m2mservices.mobi';

export const socket = io(URL, {
    autoConnect: true,
    reconnection: true
});
